'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BaseTileTargetAdditional = renderWithRef('BaseTileTargetAdditional', null, (a, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-base-tile-target-additional'
        ],
        props: a,
        children: a.children
    }));

export { BaseTileTargetAdditional };
